export const handleClearChip = (id, chipValues, setChipValues) => {
    if (!setChipValues) return;
    const newChipValues = chipValues?.filter((chip) => chip.id !== id) || [];
    setChipValues(newChipValues);
};

export const handleClearAllChips = (onClearChips, setChipValues) => {
    if (onClearChips) {
        onClearChips();
        return;
    }
    if (setChipValues) {
        setChipValues([]);
    }
};
